import { CustomerBalances } from '@src/containers/Dealer/CustomerBalances';
import type { CustomerBalancesBlotterPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CustomerBalancesPanel({ params, api }: LayoutPanelProps<CustomerBalancesBlotterPanelConfig>) {
  return (
    <BlotterPanel
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-balances-blotter-panel"
    >
      <CustomerBalances showHeader={false} hideBlotterActions={true} layout="panel" />
    </BlotterPanel>
  );
}
